import UsedGifts from '../../components/pages/mypages/UsedGifts'
export default {
  components: { UsedGifts }
}
